/**
 * @module calculatorRoi
 */

module.exports = function() {
    const toggleElements = () => {
        const calculatorOptions = document.getElementById( 'calculator-options' );
        const calculateStep = document.getElementById( 'calculate-step' );
        const resultsStep = document.getElementById( 'results-step' );

        calculatorOptions.classList.toggle( 'pe-none' );
        calculatorOptions.classList.toggle( 'opacity-50' );
        calculateStep.classList.toggle( 'd-none' );
        resultsStep.classList.toggle( 'd-none' );
    };

    document.addEventListener( 'wpcf7mailsent', () => {
        toggleElements();
        document.querySelector( '.wpcf7-response-output' ).classList.add( 'd-none' );

        setTimeout( () => {
            toggleElements();
        }, 5000 );
    }, false );
}; // exports
